import { Flex, useTheme } from "@aws-amplify/ui-react";

export function SignInFooter() {
  const { tokens } = useTheme();

  return (
    <Flex justifyContent="center" padding={`0 0 ${tokens.space.medium}`}></Flex>
  );
}
